import { get} from './api';
import URLS from '@/constants/api';

export const getBusinessWithDocs = async (businessId: string) => { 

    const endpoint = `${URLS.GET_BUSINESS_EDIT_DOCUMENTS}/${businessId}`;
    const response = await get(endpoint);
    return response;
};
